import api from '@pray/shared/utils/api';

import type { WorkflowResponse } from './data/response';
import type { UpdateWorkflowRequest } from './data/types';

type UpdateWorkflowProps = {
  artistId: string;
  workflowId: string;
  data: UpdateWorkflowRequest;
};

export async function updateWorkflow({ artistId, workflowId, data }: UpdateWorkflowProps): Promise<WorkflowResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!workflowId) throw new Error('Workflow ID is required');

  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}`;

  const response = await api.executePutRequest<WorkflowResponse>(url, data);
  return response.data;
}
